"use client";

import { IQButton } from "./iq-button";

/**
 * Exact replica of the SearchIcon from the main site (icons/search.tsx).
 * 24x24 SVG with strokeWidth 1.2, using currentColor.
 */
function SearchIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.198 14.6312L14.6324 15.1969L19.4344 20L20 19.4343L15.198 14.6312Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3991 16.8012C13.9332 16.8012 16.7982 13.9356 16.7982 10.4006C16.7982 6.86566 13.9332 4 10.3991 4C6.86496 4 4 6.86566 4 10.4006C4 13.9356 6.86496 16.8012 10.3991 16.8012Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export interface SearchButtonProps {
  onClick?: () => void;
}

export function SearchButton({ onClick }: SearchButtonProps) {
  return (
    <IQButton
      size="sm"
      rounded
      color="greyLight"
      variant="fill"
      icon={<SearchIcon />}
      onClick={onClick}
    >
      Search
    </IQButton>
  );
}
